module.exports = __webpack_public_path__ + "img/photo-2.3669a8a8.jpg";